import React from "react";
import Header from "../../CommonComponents/header";
import { Footer } from "../../CommonComponents/footer";
import { AboutHeroSection } from "./Components/aboutHeroSection";
import { ChairManMessageSection } from "./Components/chairManMessageSection";
import { StorySection } from "./Components/storySection";
import { VisionMissionSection } from "./Components/vision&missionSection";
import { MobileHeader } from "../../CommonComponents/mobileHeader";
import QualityPolicyObjective from "./Components/QualityPolicyObjective";
import InHouseFacilityAndStrength from "./Components/InHouseFacilityAndStrength";
import { Img } from "../../subComponents/img";
import { Heading } from "../../subComponents/Heading";

function AboutUspage() {
  return (
    <>
      <Header />
      <MobileHeader />
      <div className="mobile_header_spacer"></div>
      <div className="desktop_header_spacer"></div>
      <AboutHeroSection />
      <div id="chairman-message"></div>
      <ChairManMessageSection
        name={"Mr. Shailender"}
        post={"Managing Director"}
        imageUrl={"/assets/images/AboutUs/avatar.png"}
        text={
          <>
            We specialize in delivering high-quality, precision-engineered
            solutions designed to meet the evolving needs of modern industries.
            Our focus is on combining technical expertise, reliable processes,
            and customized approaches to ensure optimal performance and
            efficiency.
            <br /><br />
            With advanced manufacturing capabilities and strict quality control,
            we provide products and services that are durable, consistent, and
            tailored to client requirements. Our team is committed to
            innovation, practical problem-solving, and responsive support,
            making us a trusted partner for businesses seeking reliability and
            excellence in every project.
          </>
        }
      />
      {/* <ChairManMessageSection
        name={"Mr. Chairman Name"}
        post={"Chairman"}
        imageUrl={"/assets/images/AboutUs/avatar.png"}
        text={
          <>
           Lorem ipsum, <strong>dolor</strong> sit amet consectetur adipisicing elit. Modi ipsum odit ducimus doloribus, aliquid nisi dicta repudiandae expedita mollitia blanditiis sint recusandae dolore totam consectetur temporibus consequatur, ipsa reprehenderit maxime cum voluptate numquam distinctio architecto repellendus vitae? Error at aliquam et ad dolorem earum architecto excepturi placeat eligendi? Minima debitis quasi <strong>consequuntur</strong> tempora dolore voluptate veritatis aspernatur maxime dolores quisquam ipsum, quidem libero ad ipsam non beatae accusantium tenetur esse nam qui dolorem magni sint! Labore culpa voluptatem soluta sint.
          </>
        }
      /> */}
      {/* <ChairManMessageSection
        name={"Mr. Managing Director Name"}
        post={"Managing Director"}
        imageUrl={"/assets/images/AboutUs/avatar.png"}
        text={
          <>
            <strong>Vijay Gupta</strong> Lorem ipsum dolor sit amet consectetur,
            adipisicing elit. Expedita perferendis debitis sit necessitatibus
            hic deserunt sapiente, reprehenderit magnam dicta? Quae doloremque
            suscipit tenetur. Totam corporis facere quam consequuntur excepturi
            adipisci ut. Eligendi ipsa officia ad, est error at blanditiis
            deserunt omnis similique, impedit quis velit esse delectus rerum
            molestias nihil ipsum nobis earum expedita libero sint soluta quasi
            sunt. Itaque perferendis asperiores dolorem velit ut repellat
            perspiciatis possimus pariatur minus provident? Perferendis aliquam
            iure nostrum soluta iusto animi fuga excepturi! Voluptatum repellat
            architecto non debitis libero. Placeat quo laborum eos?
          </>
        }
      /> */}
      {/* <div
        className="message_container_right bottom_message"
        data-aos="fade-left"
      >
        <div className="innermessage_container">
          <div className="manager_container" style={{ width: "100%" }}>
            <Text text={"Mr. Vijay Gupta"} style={{ textAlign: "left" }} />
            <div style={{ width: "max-content" }}>
              <Text text={"Managing Director "} />
            </div>
          </div>
          <Text
            text={`
                  Vijay Gupta is the dynamic and visionary Managing Director of Tube Flex India, a leading force in the aluminum industry. He brings extensive expertise and a forward-thinking mindset to his leadership role. Vijay actively drives Product and Research Development, ensuring Tube Flex India remains at the cutting edge through the exploration of new materials and the optimization of production for innovative aluminum solutions. His meticulous approach extends to Reviewing Production, where he upholds stringent quality standards and operational efficiency, guaranteeing the delivery of superior products.
        `}
            style={{ fontSize: "1rem" }}
          />
          <Text
            text={`
                  Beyond operations, Vijay champions exceptional Customer Service, cultivating a customer-centric culture focused on responsiveness and building lasting partnerships. Looking ahead, he is the driving force behind Tube Flex India's Growth Vision, strategically pursuing expansion into new markets and fostering continuous improvement to solidify the company's leadership. His passion for the aluminum sector and unwavering commitment to excellence make Vijay Gupta an invaluable asset and a respected leader within the industry.
        `}
            style={{ fontSize: "1rem" }}
          />
        </div>
      </div> */}

      <div className="">
        <Heading
          orangeheading={"Our"}
          title={"Team"}
          data-aos="zoom-in"
          style={{ textAlign: "center" }}
        />
        <br />
        <Img src={"/assets/images/AboutUs/team-member.png"} alt={"Our Team"} />
      </div>
      <br /><br />
      <div id="our-story"></div>
      <StorySection />
      <div id="vision-&-mission"></div>
      <VisionMissionSection />
      <QualityPolicyObjective />
      <InHouseFacilityAndStrength />
      <Footer />
    </>
  );
}
export default AboutUspage;
